<script>
export default {
    name: 'IconArrowheadLeft',
}
</script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="base-icon icon-arrowhead-left" viewBox="0 0 64 64"><path fill="currentColor"  fill-rule="evenodd" d="M44.6 0 14 31.867l.129.132-.129.133L44.6 64l5.4-5.624L24.673 32 50 5.624 44.6 0Z" clip-rule="evenodd"/></svg>
</template>
